export const GET_LOGIN_BEGIN = "GET_LOG_IN_BEGIN";
export const GET_LOGIN_SUCCESS = "GET_LOG_IN_SUCCESS";
export const GET_LOGIN_FAIL = "GET_LOG_IN_FAIL";

export const REGISTER_BEGIN = "REGISTER_BEGIN"
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"
export const REGISTER_FAIL = "REGISTER_FAIL"

export const SIGNUP_BEGIN = "SIGNUP_BEGIN"
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS"
export const SIGNUP_FAIL = "SIGNUP_FAIL"

export const PAGINATION_BEGIN = "PAGINATION_BEGIN";
export const PAGINATION_SUCCESS = "PAGINATION_SUCCESS";
export const PAGINATION_FAIL = "PAGINATION_FAIL";

export const GET_LOCATION_BEGIN = "GET_LOCATION_BEGIN"
export const GET_LOCATION_SUCCESS = "GET_LOCATION_SUCCESS"
export const GET_LOCATION_FAIL = "GET_LOCATION_FAIL"

export const GET_ORDER_BEGIN = "GET_ORDER_BEGIN"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_FAIL = "GET_ORDER_FAIL"
export const GET_MYORDER_BEGIN = "GET_MYORDER_BEGIN"
export const GET_MYORDER_SUCCESS = "GET_MYORDER_SUCCESS"
export const GET_MYORDER_FAIL = "GET_MYORDER_FAIL"
export const PATCH_ORDER_BEGIN = "PATCH_ORDER_BEGIN"
export const PATCH_ORDER_SUCCESS = "PATCH_ORDER_SUCCESS"
export const PATCH_ORDER_FAIL = "PATCH_ORDER_FAIL"
export const POST_PAYMENT_BEGIN = "POST_PAYMENT_BEGIN"
export const POST_PAYMENT_SUCCESS = "POST_PAYMENT_SUCCESS"
export const POST_PAYMENT_FAIL = "POST_PAYMENT_FAIL"

export const GET_RECIPE_BEGIN = "GET_RECIPE_BEGIN"
export const GET_RECIPE_SUCCESS = "GET_RECIPE_SUCCESS"
export const GET_RECIPE_FAIL = "GET_RECIPE_FAIL"
export const GET_MYRECIPE_BEGIN = "GET_MYRECIPE_BEGIN"
export const GET_MYRECIPE_SUCCESS = "GET_MYRECIPE_SUCCESS"
export const GET_MYRECIPE_FAIL = "GET_MYRECIPE_FAIL"
export const DELETE_RECIPE_BEGIN = "DELETE_RECIPE_BEGIN"
export const DELETE_RECIPE_SUCCESS = "DELETE_RECIPE_SUCCESS"
export const DELETE_RECIPE_FAIL = "DELETE_RECIPE_FAIL"
export const GET_RECIPE_DETAILS_BEGIN = "GET_RECIPE_DETAILS_BEGIN"
export const GET_RECIPE_DETAILS_SUCCESS = "GET_RECIPE_DETAILS_SUCCESS"
export const GET_RECIPE_DETAILS_FAIL = "GET_RECIPE_DETAILS_FAIL"

export const GET_FILTER_RECIPE_BEGIN = "GET_FILTER_RECIPE_BEGIN"
export const GET_FILTER_RECIPE_SUCCESS = "GET_FILTER_RECIPE_SUCCESS"
export const GET_FILTER_RECIPE_FAIL = "GET_FILTER_RECIPE_FAIL"
export const GET_SEARCH_RECIPE_BEGIN = "GET_SEARCH_RECIPE_BEGIN"
export const GET_SEARCH_RECIPE_SUCCESS = "GET_SEARCH_RECIPE_SUCCESS"
export const GET_SEARCH_RECIPE_FAIL = "GET_SEARCH_RECIPE_FAIL"

export const PATCH_PROFILE_BEGIN = "PATCH_PROFILE_BEGIN"
export const PATCH_PROFILE_SUCCESS = "PATCH_PROFILE_SUCCESS"
export const PATCH_PROFILE_FAIL = "PATCH_PROFILE_FAIL"

export const GET_USER_BEGIN = "GET_USER_BEGIN"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_FAIL = "GET_USER_FAIL"

export const PATCH_USER_BEGIN = "PATCH_USER_BEGIN"
export const PATCH_USER_SUCCESS = "PATCH_USER_SUCCESS"
export const PATCH_USER_FAIL = "PATCH_USER_FAIL"

export const GET_REVIEW_BEGIN = "GET_REVIEW_BEGIN"
export const GET_REVIEW_SUCCESS = "GET_REVIEW_SUCCESS"
export const GET_REVIEW_FAIL = "GET_REVIEW_FAIL"
export const GET_RATING_BEGIN = "GET_RATING_BEGIN"
export const GET_RATING_SUCCESS = "GET_RATING_SUCCESS"
export const GET_RATING_FAIL = "GET_RATING_FAIL"
export const POST_REVIEW_BEGIN = "POST_REVIEW_BEGIN"
export const POST_REVIEW_SUCCESS = "POST_REVIEW_SUCCESS"
export const POST_REVIEW_FAIL = "POST_REVIEW_FAIL"
export const POST_RATING_BEGIN = "POST_RATING_BEGIN"
export const POST_RATING_SUCCESS = "POST_RATING_SUCCESS"
export const POST_RATING_FAIL = "POST_RATING_FAIL"
export const DELETE_REVIEW_BEGIN = "DELETE_REVIEW_BEGIN"
export const DELETE_REVIEW_SUCCESS = "DELETE_REVIEW_SUCCESS"
export const DELETE_REVIEW_FAIL = "DELETE_REVIEW_FAIL"

export const POST_CART_BEGIN = "POST_CART_BEGIN"
export const POST_CART_SUCCESS = "POST_CART_SUCCESS"
export const POST_CART_FAIL = "POST_CART_FAIL"

export const GET_CART_BEGIN = "GET_CART_BEGIN"
export const GET_CART_SUCCESS = "GET_CART_SUCCESS"
export const GET_CART_FAIL = "GET_CART_FAIL"

export const POST_CREATE_BEGIN = "POST_CREATE_BEGIN"
export const POST_CREATE_SUCCESS = "POST_CREATE_SUCCESS"
export const POST_CREATE_FAIL = "POST_CREATE_FAIL"

export const PUT_CREATE_BEGIN = "PUT_CREATE_BEGIN"
export const PUT_CREATE_SUCCESS = "PUT_CREATE_SUCCESS"
export const PUT_CREATE_FAIL = "PUT_CREATE_FAIL"

export const PUT_CREATE_STEP_THREE_BEGIN = "PUT_CREATE_STEP_THREE_BEGIN"
export const PUT_CREATE_STEP_THREE_SUCCESS = "PUT_CREATE_STEP_THREE_SUCCESS"
export const PUT_CREATE_STEP_THREE_FAIL = "PUT_CREATE_STEP_THREE_FAIL"

export const PUT_CREATE_STEP_FOUR_BEGIN = "PUT_CREATE_STEP_FOUR_BEGIN"
export const PUT_CREATE_STEP_FOUR_SUCCESS = "PUT_CREATE_STEP_FOUR_SUCCESS"
export const PUT_CREATE_STEP_FOUR_FAIL = "PUT_CREATE_STEP_FOUR_FAIL"

export const GET_SELLER_BEGIN = "GET_SELLER_BEGIN"
export const GET_SELLER_SUCCESS = "GET_SELLER_SUCCESS"
export const GET_SELLER_FAIL = "GET_SELLER_FAIL"
